import axios from "axios";
import { IActionStatus } from "@/shared/model/actions-status.model";

const baseApiUrl = "api/actions";

export default class actionPanelService {
  public recompute360(id): Promise<IActionStatus> {
    return new Promise<IActionStatus>(function (resolve, reject) {
      axios
        .get(`${baseApiUrl}/recompute-360/${id}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public encryptString(entity): Promise<any> {
    return new Promise<any>(function (resolve, reject) {
      axios
        .post(`${baseApiUrl}/encrypt-string`, entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public decryptString(entity): Promise<any> {
    return new Promise<any>(function (resolve, reject) {
      axios
        .post(`${baseApiUrl}/decrypt-string`, entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
